import { createGlobalStyle, keyframes } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
:root {
  --box-shadow: 0px 0px 4px #000000;
}

html,
body,
input,
textarea,
select,
option,
button {
  font-family: ${props => props.theme.typography.fontFamily.sans};
  color: ${props => props.theme.colors.lighter};
  background-color: ${props => props.theme.colors.level3b};
}

html,
body {
  margin: 0;
}

body {
  background-color: ${props => props.theme.colors.level3b};
  margin: 0;
  padding: 0;
  position: relative;
  backface-visibility: hidden;
}

p,
input,
button,
label {
  margin: 0;
}

a {
  color: ${props => props.theme.colors.lighter};
  text-decoration: none;
}

div:focus {
  outline: 0;
}

::-webkit-scrollbar-track {
  background-color: rgba(255, 255, 255, 0);
}

::-webkit-scrollbar {
  margin-left: 3px;
  width: ${props => props.theme.dimensions.scrollbar.width};
  background-color: rgba(255, 255, 255, 0);
}

::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border: 4px solid rgba(0, 0, 0, 0);
  border-radius: 1em;
  background-clip: padding-box;
}

::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}

.scrollable-dropdown-menu::-webkit-scrollbar-track {
  background-color: rgba(255, 255, 255, 0);
}

.scrollable-dropdown-menu::-webkit-scrollbar {
  margin-left: 3px;
  background-color: rgba(255, 255, 255, 0);
}

.scrollable-dropdown-menu::-webkit-scrollbar-thumb {
  background-color: rgba(150, 150, 150, 0.1);
  border: 1px solid rgba(150, 150, 150, 0.1);
  background-clip: padding-box;
}

.scrollable-dropdown-menu::-webkit-scrollbar-corner {
  background-color: transparent;
}

`;

export default {
  animations: {
    fadeIn: keyframes`
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }`,
    spin: keyframes`
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }`,
    pulse: keyframes`
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
            opacity: 0;
        }`,
    fadeInBlack: keyframes`
        0% {
            background-color: transparent;
        }
        100% {
            background-color: rgba(0, 0, 0, 0.8);
        }`,
    moveInFromTop: keyframes`
        0% {
            transform: translateY(-50%);
        }
        100% {
            transform: translateY(0px);
        }`,
    moveInFromBottom: keyframes`
        0% {
            transform: translateY(150%);
        }
        100% {
            transform: translateY(0px);
        }`,
  },
  colors: {
    level1: '#464646',
    level2: '#363636',
    level3a: '#363636',
    level3b: '#262626',
    headerLevel: '#262626',
    contentLevel: '#161616',
    modalLevel: '#262626',
    footerLevel: '#262626',
    darkest: '#171717',
    dark: '#2b2b2b',
    medium: '#616161',
    mediumLight: '#adadad',
    light: '#e0e0e0',
    lighter: '#f5f5f5',
    red: '#c81618',
    redDark: '#820316',
    protonesRed: '#781e1e',
    green: '#62e262',
    yellow: '#ff0',
    select: '#212121',
    transparent: 'rgba(23, 23, 23, 0.92)',
    transparentWhite: 'rgba(245, 245, 245, 0.8)',
    primary: '#c81618',
    secondary: '#820316',
    playerBackground: '#262626',
    border: 'rgba(255, 255, 255, 0.4)',
    borderDark: 'rgba(200, 200, 200, 0.4)',
  },
  dimensions: {
    header: {
      height: '140px',
    },
    player: {
      height: '64px',
    },
    scrollbar: {
      width: '1.2em',
    },
    border: {
      width: '1px',
    },
    zIndex: {
      modal: 800,
      version: 700,
      header: 600,
      footer: 500,
      snackbar: 400,
      side: 200,
    },
  },
  typography: {
    fontFamily: {
      sans: "'Montserrat', sans-serif",
      mono: "'Droid Sans Mono', sans-serif",
    },
    fontSize: {
      xxs: '9px',
      xs: '11px',
      s: '13px',
      m: '15px',
      l: '17px',
      xl: '20px',
      xxl: '26px',
    },
    lineHeight: {
      s: '18px',
      m: '20px',
      l: '30px',
    },
    fontWeight: {
      s: 300,
      m: 400,
      l: 500,
      xl: 600,
      xxl: 700,
    },
  },
};
